<template>
	<div>
		<app-alerpop v-if="((Object.keys(editalert).length > 0 && editalert.Symbol) || alertTab)  &&  instruments[alertTab?currency_pair:editalert.Symbol]" :currency_pair="editalert.Symbol || currency_pair" :editalert="editalert"></app-alerpop>
		<div class="leftData scrollbar">
			<div class="custom-modal">{{checkWS}}
				<ul class="toggleButton d-inline-flex align-items-center justify-content-center">
					<li :class="(alertType === 1)?'active':''" class="text-center">
							
							<a class="borderColored" href="#" @click.prevent="alertType = 1">{{$t('active') }} <span></span></a>
					</li>
					<li :class="(alertType === 0)?'active':''" class="text-center">
						<a class="borderColored" href="#" @click.prevent="alertType = 0">{{$t('triggered') }} <span></span></a>
					</li>
				</ul>
			</div>
			<div class="accordianCal" v-if="alertType == 1">
				<div class="showCal border-bottom d-block position-relative opacity h-100" v-for="list in activePriceAlert">
					 <div class="d-flex justify-content-between align-items-center mainTPS">
						 <div class="d-flex ftQR"> 
						   <!-- <span class="crncyIcon"><img src="../../../../../static/website/images/switzerland-1.svg" alt="Icon"></span>	 -->
						   <span class="rightText">
						   <h5 class="m-0">{{list.Symbol}}</h5>
						   <!-- <p class="small m-0 d-block">05:30 am</p> -->
						   </span>
						 </div>
						 <div class="ftQRC">
							 <h5 class="m-0">{{$t('condition') }} </h5>
							 <p class="m-0 f-12 d-flex align-items-center opacity">
								 {{list.Type}}
								 <feather size="12px" class="green mr-1" type="chevron-up" v-if="getHighLow(list)"></feather>
								 <feather size="12px" class="red mr-1" type="chevron-down" v-else></feather>
								 {{list.Price}}
							 </p>
						 </div>
						 <div class="conditionSymbol">
							 <div class="rightEdit-delete d-flex align-items-center" v-if="delList.includes(list.AlertID)">
								<a @click.prevent="" href="#" class="td-button mr-1 disabled">
									<feather size="12px" type="edit"></feather>
								</a>
								<a @click.prevent="" href="#" class="td-button disabled">
									<feather size="12px" type="x"></feather>
								</a>
							</div>
							 <div class="rightEdit-delete d-flex align-items-center" v-else>
								<a @click.prevent="edit(list)" href="#" class="td-button mr-1">
									<feather size="12px" type="edit"></feather>
								</a>
								<a @click.prevent="closingAlert(list,'active')" href="#" class="td-button">
									<feather size="12px" type="x"></feather>
								</a>
							</div>
						 </div>
					 </div>
					 <div class="mt-2" v-if="list.Commentary">
						  <p class="mb-0">{{list.Commentary}}</p>
					 </div>
				 </div>
				 <app-loader v-if="pageLoader"/>
				 <div v-else-if="activePriceAlert.length != 0">
					<a href="javascript:void(0)" class="d-flex f-14 flex-column justify-content-center text-center mt-6" @click="alertTab = true">{{$t('create_new_alert') }} </a>
				 </div>
				 <div v-else-if="activePriceAlert.length == 0">
					<no-data class="noData mt-4 h-100 d-flex justify-content-center flex-column" text="No Alerts were set"/>
					<a href="javascript:void(0)" class="d-flex f-14 flex-column justify-content-center text-center" @click="alertTab = true">{{$t('create_alert') }}</a>
				 </div>
			</div>
			<div class="accordianCal" v-else-if="alertType == 0">
				 <div class="showCal border-bottom d-block position-relative opacity h-100" v-for="list in triggeredPriceAlert">
					 <div class="d-flex justify-content-between align-items-center mainTPS">
						 <div class="d-flex ftQR"> 
						   <!-- <span class="crncyIcon"><img src="../../../../../static/website/images/switzerland-1.svg" alt="Icon"></span>	 -->
						   <span class="rightText">
						   <h5 class="m-0">{{list.Symbol}}</h5>
						   <p class="small m-0 d-block">{{Getdate(list.Triggered)}}</p>
						   </span>
						 </div>
						 <div class="ftQRC">
							 <h5 class="m-0">{{$t('condition') }} </h5>
							 <p class="m-0 f-12 d-flex align-items-center opacity">
								 {{list.Type}}
								 <feather size="12px" class="green mr-1" type="chevron-up" v-if="getHighLow(list)"></feather>
								 <feather size="12px" class="red mr-1" type="chevron-down" v-else></feather>
								 {{list.Price}}
							 </p>
						 </div>
						 <div class="conditionSymbol">
							 <div class="rightEdit-delete d-flex align-items-center">
								<!-- <a @click.prevent="" href="#" class="td-button mr-1">
									<feather size="12px" type="edit"></feather>
								</a> -->
								<a href="#" class="td-button disabled" @click.prevent="" v-if="delList.includes(list.AlertID)">
									<feather size="12px" type="x"></feather>
								</a>
								<a href="#" class="td-button" @click.prevent="closingAlert(list,'triggered')" v-else>
									<feather size="12px" type="x"></feather>
								</a>
							</div>
						 </div>
					 </div>
					 <!-- <div class="mt-2">
						  <p class="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
					 </div> -->
				 </div>
				 <app-loader v-if="pageLoader"/>
				 <no-data class="noData mt-4 h-100 d-flex justify-content-center flex-column" v-else-if="triggeredPriceAlert.length == 0" text="No Alerts were set"/>
			 </div>
		</div>
		<!--Edit alert-->
		<!-- <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(editalert).length > 0">
			<div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
				<app-loader v-if="pageLoader"/>
				<span class="closePOP" @click.prevent="editalert = {};editalertTempId = ''"><feather size="13px" type="x"></feather></span>
				<div class="pop-head-title">
					<p class="mb-3">Edit Price Alert </p>
				</div>
				<div class="topSettingHead position-relative border-bottom p-3 updateWrap" v-if="editalertTempId == ''">
					<div class="form-fields">
						<input type="number" class="form-controls" placeholder="Price" :step="getStep(editalert.Price)" name="watchlist" v-model="editalert.Price" v-validate="'required|decimal:5'"/>
						<span class="text-danger" v-if="submitted && errors.has('watchlist')">{{ errors.first('watchlist').replace('watchlist', 'Price') }}</span>
						<div class="form-fields mt-4" :class="[{'validation-error':submitted && errors.has('Comment')}]">
							<div class="d-flex align-items-center justify-content-between maximumChar">
								<label class="commentBox">Add Comment</label>
								<p class="charterOnly m-0">Maximum 100 characters <span class="green ml-2">{{editalert.Commentary.length}} / <span class="ltr-char">100</span></span> </p>
							</div>
							<textarea class="textarea" maxlength="100" v-model="editalert.Commentary" name="Comment" v-validate="'max:100'"></textarea>
							<span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
						</div>
						<button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="update()">Submit</button>
					</div>
				</div>
				<div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else-if="editalertTempId != '' && !wsOrder.hasOwnProperty(editalertTempId)">
					<div class="fields-wrappers">
						<div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
							<feather size="28px" type="clock"></feather>
						</div>
						<div class="loadShow">
							<app-loader />
						</div>
						<button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="editalert = {};editalertTempId = ''">Close</button>
					</div>
				</div>
				<div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else-if="wsOrder.hasOwnProperty(editalertTempId)">
					<div class="fields-wrappers">
						<div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
							<feather size="28px" type="check-circle" v-if="wsOrder[editalertTempId].stat == 'OK'"></feather>
							<feather size="28px" type="alert-triangle" v-else></feather>
						</div>
						<h3 :class="(wsOrder[editalertTempId].stat == 'OK')?'green':'red'" v-html="wsOrder[editalertTempId].resp_msg"></h3>
						<h3 class="mb-3 green">Watchlist has been Updated successfully</h3>
						<button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="editalert = {};editalertTempId = ''">Close</button>
					</div>
				</div>
			</div>
		</div> -->
		<!-- Delete alert-->
		<div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(closing_alert).length > 0">
			<div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
				<app-loader v-if="pageLoader"/>
				<span class="closePOP" @click.prevent="closing_alert = {}"><feather size="13px" type="x"></feather></span>
				<div class="pop-head-title">
					<p class="m-0 f-15 uppercase currency_pair red">{{closing_alert.type}}</p>
				</div>
				<div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap">
					<div class="fields-wrappers">
						<div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
							<feather class="red" size="28px" type="trash-2"></feather>
						</div>
						<div class="d-flex text-center justify-content-center mb-2">
							   <span class="rightText">
								   <h5 class="m-0">{{closing_alert.Symbol}}</h5>
								   <!-- <p class="small m-0 d-block">05:30 am</p> -->
							   </span>
							 <p class="m-0 f-12 d-flex align-items-center opacity">
								 <feather size="12px" class="green mr-1" type="chevron-up" v-if="getHighLow(closing_alert)"></feather>
								 <feather size="12px" class="red mr-1" type="chevron-down" v-else></feather>
								 {{closing_alert.Price}}
							 </p>
						 </div>
						<h3 class="mb-3">{{$t('delete_alert') }} </h3>
						<div class="d-flex align-items-center justify-content-center mt-4">
							<button href="#" class="noAdd white mr-3" @click="closing_alert = {}">{{$t('no') }} </button>
							<button class="btn appButton linkBG justify-content-center" @click="close(closing_alert.AlertID,closing_alert.type);closing_alert = {}">{{$t('Yes') }} </button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Const } from '@/plugins/vue-provider-cache/const.mod'
	import { commonAllmixins } from '@/plugins/commonAll'
	import app_alerpop from '../../shared/price-alert'
	import moment from 'moment'
	export default {
		name: 'Right-Section',
		mixins: [commonAllmixins],
		data() {
			return {
				pageLoader : false,
				alertTab : false,
				submitted : false,
				alertType : 1,
				editalert : {},
				editalertTempId : '',
				delList:[],
				delTempList:[],
				// editalert : {},
				closing_alert : {},
			}
		},
		props:['currency_pair'],
		components:{
			appAlerpop : app_alerpop
		},
		methods:{
			edit(list){
				this.editalert = Object.assign({}, list);
			},
			getStep(val){
				if(val.toString().includes('.')){
					return (1/Math.pow(10, val.toString().split('.')[1].length)).toString()
				}else{
					return '1'
				}
			},
			closingAlert(list,type){
				this.closing_alert = list 
				this.closing_alert['type'] = type 
			},
			close(id,type){
				this.delList.push(id)
				const tempOrderId = new Date().getTime()
				this.delTempList.push(tempOrderId)
				let data = {
					'alert_id':id ,
					'tempOrderId' : tempOrderId,
					'type' : type // active,triggered
				}
				this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].removePriceAlert(data)
			},
			update(){
				var _that = this
				this.submitted =  true
				_that.$validator.validate().then(valid => {
					if (valid && !_that.orderPlacedWait) {
						const tempOrderId = new Date().getTime()
						this.submitted =  false
						let orderJson = {
							"alert_id" : _that.editalert.AlertID,
							"price" : _that.editalert.Price,
							"tempOrderId" : tempOrderId,
							"Commentary" : _that.editalert.Commentary,
							"localParams" : _that
						}
						this.editalertTempId = orderJson.tempOrderId
						// console.log('order',orderJson)
						this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].modifyPriceAlert(orderJson)
					}
				});
			},
			Getdate(key){
				let d = new Date(key);
				return moment(d).format('hh:mm a')
			},
			getHighLow(list){
				try{
					return list.Price > this.instruments[list.Symbol][list.Type.charAt(0)]
				}catch(e){ return false; }
			},
			successWs(){
				// console.log('cancle Order ws')
			},
			failedWs(){
				this.displayError('There is some network issue','error')
			},
			displayError(getMessage,type){
				this.$notify({
					group: 'foo',
					type: (type && type == null)?'error':type,
					text: getMessage,
					duration: 4000,
					closeOnClick: true
				});
			},
		},
		computed:{
			checkWS(){
				let _that = this
				this.delTempList.forEach(val=>{
					if(_that.wsOrder.hasOwnProperty(val)){
						let msg = _that.wsOrder[val].resp_msg
						let msgType = (_that.wsOrder[val].stat == 'OK')?'success':'error'
						_that.displayError(msg,msgType)
						_that.delTempList.splice(_that.delTempList.indexOf(val), 1)
					}
				})
			},
			instruments() {
				try {                    
					this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
					return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
				} catch (ex) {                
					return []
				}
			},
		},
		created(){
			if(this.activePriceAlert.length == 0){
				this._runGetActivePriceAlert({'globalParams' : {} ,'localParams' : {'parameter' : this}})
			}
			if(this.triggeredPriceAlert.length == 0){
				this._runGetTriggeredPriceAlert({'globalParams' : {} ,'localParams' : {'parameter' : this}})
			}
		}
		
	}
</script>


// WEBPACK FOOTER //
// src/components/website/user/home-elements/price-alert-tab.vue